import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { FormsModule } from "@angular/forms";
import { ReactiveFormsModule } from "@angular/forms";

import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatIconModule } from "@angular/material/icon";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSelectModule } from "@angular/material/select";
import { MatChipsModule } from "@angular/material/chips";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatTabsModule } from "@angular/material/tabs";
import { SharedAccessModule } from "./shared/shared-access.module";
import { MenuModule } from "./menu/menu.module";

import { DashboardComponent } from "./dashboard/dashboard.component";
import { SharedModule } from "./shared.module";
import { ApplicationsComponent } from "./applications/applications.component";

import { AssessmentDetailComponent } from "./assessments/assessment-detail.component";
import { AIConfigComponent } from "./admin/ai-config/ai-config.component";
import { AiChatSettingsComponent } from "./admin/ai-chat-settings/ai-chat-settings.component";
import { AiConnectionsComponent } from "./admin/ai-connections/ai-connections.component";
import { AiCmdbAssessmentComponent } from "./admin/ai-cmdb-assessment/ai-cmdb-assessment.component";
import { CmdbSyncComponent } from "./admin/cmdb-sync/cmdb-sync.component";
import { CmdbManagementComponent } from "./admin/cmdb-management/cmdb-management.component";
import { ModernizationReadinessComponent } from "./admin/modernization-readiness/modernization-readiness.component";
import { JobLogsComponent } from "./admin/modernization-readiness/job-logs.component";
import { UsersSyncComponent } from "./admin/users-sync/users-sync.component";
import { UsersListComponent } from "./admin/users-list/users-list.component";
import { PodsListComponent } from "./admin/pods-list/pods-list.component";
import { ApplicationComponent } from "./admin/application/application.component";
import { ApplicationSettingsComponent } from "./admin/application-settings/application-settings.component";
import { PlatformMasterComponent } from "./admin/platformmaster/platform-master.component";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { MatDialogModule } from "@angular/material/dialog";
import { MessageDialogComponent } from "./shared/message-dialog/message-dialog.component";
import { StartAssessmentDialogComponent } from "./shared/start-assessment-dialog/start-assessment-dialog.component";
import { NotesDialogComponent } from "./applications/Notes/notes-dialog.component";
import { DataGridComponent } from "./shared/data-grid/data-grid.component";
import { ApplicationHistoryDialogComponent } from "./applications/application-history/application-history-dialog.component";
import { LogoutComponent } from "./logout/logout.component";
import { ActionDialogComponent } from "./shared/action-dialog/action-dialog.component";
import { PatUpdateDialogComponent } from "./shared/pat-update-dialog/pat-update-dialog.component";
import { UserGuideComponent } from "./user-guide/user-guide.component";
import { ConflictCandidatesPageComponent } from "./dashboard/conflict-candidates-page/conflict-candidates-page.component";
import { PersonalAccessTokensComponent } from "./personal-access-tokens/personal-access-tokens.component";

const standaloneComponents = [
  DashboardComponent,
  ApplicationsComponent,
  AssessmentDetailComponent,
  AIConfigComponent,
  AiChatSettingsComponent,
  AiConnectionsComponent,
  AiCmdbAssessmentComponent,
  CmdbSyncComponent,
  CmdbManagementComponent,
  ModernizationReadinessComponent,
  JobLogsComponent,
  UsersSyncComponent,
  UsersListComponent,
  PodsListComponent,
  ApplicationComponent,
  ApplicationSettingsComponent,
  PlatformMasterComponent,
  NotesDialogComponent,
  MessageDialogComponent,
  StartAssessmentDialogComponent,
  DataGridComponent,
  ApplicationHistoryDialogComponent,
  LogoutComponent,
  ActionDialogComponent,
  PatUpdateDialogComponent,
  UserGuideComponent,
  ConflictCandidatesPageComponent,
  PersonalAccessTokensComponent
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatDialogModule,
    MatSelectModule,
    MatChipsModule,
    MatAutocompleteModule,
    SharedModule,
    SharedAccessModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatSlideToggleModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatTabsModule,
    MenuModule,
    ...standaloneComponents,
  ],
  exports: standaloneComponents,
})
export class PagesModule { }

